import React from "react";
import ReportUtilities from "../component/reportUtilities";

function ReportUtilitiesContainer() {
  return <ReportUtilities />;
}

export default ReportUtilitiesContainer;
